
import { Options, Vue, prop } from "vue-class-component";
import { PropType } from "vue";
import SelectSearch from "@/app/ui/components/select-search/index.vue";
import debounce from "lodash/debounce";
import LpButton from "@/app/ui/components/lp-button/index.vue";
import { ClientController } from "@/app/ui/controllers/ClientController";

class Props {
  isShown = prop<boolean>({ default: false, type: Boolean });
  onClose = prop<Function>({
    default: () => undefined,
    type: Function as PropType<() => void>
  });
}

@Options({
  components: {
    LpButton
  },
  emits: ["continue"],
  watch: {
    isShown(newVal: boolean) {
      if (newVal) {
        this.resetSearch();
      }
    }
  }
})
export default class ModalSelectClientSchedule extends Vue.with(Props) {
  selectedClient: any = null;
  clientOptions: any[] = [];
  clientPage = 1;
  clientKeyword = "";
  clientHasMore = true;
  clientSearchLoading = false;
  clientRequestSeq = 0;
  clientPageSize = 20;

  resetSearch(): void {
    this.selectedClient = null;
    this.clientOptions = [];
    this.clientPage = 1;
    this.clientKeyword = "";
    this.clientHasMore = true;
    this.clientSearchLoading = false;
  }

  async loadClientPage(keyword: string, page: number): Promise<void> {
    const seq = ++this.clientRequestSeq;
    this.clientSearchLoading = true;
    try {
      const res = await ClientController._onGetCLientMappingList({
        search: keyword,
        page,
        limit: this.clientPageSize,
        isBranch: true,
        isParent: false
      });
      if (seq !== this.clientRequestSeq) return;
      if (!res) {
        if (page === 1) {
          this.clientOptions = [];
        }
        return;
      }
      const resData = res.map(item => {
        return {
          ...item,
          clientName: `${item.clientCode} - ${item.clientName}`
        }
      })
      const data = resData.filter(
        (item: any, index: number, items: any[]) =>
          items.findIndex((x) => x.clientId === item.clientId) === index
      );
      if (page === 1) {
        this.clientOptions = data;
      } else {
        const existingIds = this.clientOptions.map((item) => item.clientId);
        this.clientOptions = [
          ...this.clientOptions,
          ...data.filter((item: any) => !existingIds.includes(item.clientId))
        ];
      }
      this.clientPage = page;
      this.clientHasMore = data.length === this.clientPageSize;
    } catch {
      if (seq === this.clientRequestSeq && page === 1) {
        this.clientOptions = [];
      }
    } finally {
      if (seq === this.clientRequestSeq) {
        this.clientSearchLoading = false;
      }
    }
  }

  onClientSearchFocus(): void {
    this.loadClientPage(this.clientKeyword, 1);
  }

  onClientSearchFilter = debounce((keyword: string) => {
    this.clientKeyword = keyword;
    this.clientPage = 1;
    this.loadClientPage(keyword, 1);
  }, 250);

  onClientSearchScrolled(): void {
    if (!this.clientHasMore || this.clientSearchLoading) return;
    this.loadClientPage(this.clientKeyword, this.clientPage + 1);
  }

  onClientSelect(item: any): void {
    this.selectedClient = item || null;
  }

  onContinue(): void {
    if (!this.selectedClient) return;
    this.$emit("continue", this.selectedClient);
  }
}
